export default "__VITE_ASSET__BhjMQ8Z3__"